export const RAMADAN_CAMPAIGN_2025_PROD = 'ramadan_campaign_2025_PROD'
export const RAMADAN_CAMPAIGN_2025_DEV = 'ramadan_campaign_2025_DEV'
export const OOREDOO_OFFER = 'qatar_travel_ooredoo_offer'
export const AIRALO_OFFER = 'qatar_travel_airalo_offer'
export const DS_QUOTE = 'qatar_travel_ds_quote'
export const SELECT_PLAN_INSURANCE_VALUES = 'qatar_travel_select_plan_ins_val'
export const GEORGIA_WINTER_COVER = 'qatar_travel_georgia_winter_cover'
export const INSURED_TRAVELERS_QC = 'qatar_travel_ds_ins_traveler'
export const PERSONAL_INFORMATION_QC = 'qatar_travel_ds_pers_info'
export const INBOUND_SELECT_PLAN_QC = 'qatar_travel_ds_inbound_plan'
export const CONTACTS_QC = 'qatar_travel_ds_contacts'
export const TRAVELERS_QC = 'qatar_travel_ds_num_travelers'
export const DATES_QC = 'qatar_travel_ds_dates'
export const FIRST_STEP_QC = 'qatar_travel_ds_first_step'
export const PROGRESS_BAR_QC = 'qatar_travel_ds_progress_bar'

export const FEATURES = [
  RAMADAN_CAMPAIGN_2025_PROD,
  RAMADAN_CAMPAIGN_2025_DEV,
  OOREDOO_OFFER,
  AIRALO_OFFER,
  DS_QUOTE,
  SELECT_PLAN_INSURANCE_VALUES,
  GEORGIA_WINTER_COVER,
  INSURED_TRAVELERS_QC,
  PERSONAL_INFORMATION_QC,
  INBOUND_SELECT_PLAN_QC,
  CONTACTS_QC,
  TRAVELERS_QC,
  DATES_QC,
  FIRST_STEP_QC,
  PROGRESS_BAR_QC,
]
export const RAMADAN_BANNER_PAGES = ['outbound-select-plans', 'outbound-quote']
